module.exports = __webpack_public_path__ + "static/media/uriel-soberanes-1511839-unsplash.24ff4bd8.jpg";